import {fetchBody, URL_CUSTOMERCONTRACT_GET_DETAIL, URL_CONTRACTORATTENDANCE_GET_SOP1_LIST, URL_CONTRACTORATTENDANCE_GET_SOP1_COUNT, URL_CONTRACTORATTENDANCE_ADD, URL_CONTRACTORATTENDANCE_GET_LIST, URL_CONTRACTORATTENDANCE_GET_DETAIL, URL_CONTRACTORATTENDANCE_GET_CUSTOMERPOSITION_RECRUITMENT_LIST, URL_CONTRACTORATTENDANCE_UPDATE, URL_CONTRACTORATTENDANCE_GET_CUSTOMERPOSITION_RECRUITMENT_CONTRACTOR, URL_CONTRACTORATTENDANCE_UPDATE_SOPSTATUS} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getContractorAttendanceList ({mReqContractorAttendanceList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendanceList, token}), 
      url: URL_CONTRACTORATTENDANCE_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getContractorAttendanceSOP1List ({mReqContractorAttendanceSOPList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendanceSOPList, token}), 
      url: URL_CONTRACTORATTENDANCE_GET_SOP1_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getContractorAttendanceSOP1Count ({mReqContractorAttendanceSOPCount, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendanceSOPCount, token}), 
      url: URL_CONTRACTORATTENDANCE_GET_SOP1_COUNT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addContractorAttendance ({mReqContractorAttendance, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendance, token}), 
      url: URL_CONTRACTORATTENDANCE_ADD, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_updateContractorAttendance ({mReqContractorAttendance, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendance, token}), 
      url: URL_CONTRACTORATTENDANCE_UPDATE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_updateContractorAttendanceSOPStatus ({mReqContractorAttendance, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendance, token}), 
      url: URL_CONTRACTORATTENDANCE_UPDATE_SOPSTATUS, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getContractorAttendanceDetail ({mReqContractorAttendanceDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendanceDetail, token}), 
      url: URL_CONTRACTORATTENDANCE_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getCustomerAttendance_CustomerPosition_Recruitment_List ({mReqCustomerPositionList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCustomerPositionList, token}), 
      url: URL_CONTRACTORATTENDANCE_GET_CUSTOMERPOSITION_RECRUITMENT_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getCustomerAttendance_CustomerPosition_Recruitment_Contractor ({mReqContractorAttendanceRecruitmentContractor, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqContractorAttendanceRecruitmentContractor, token}), 
      url: URL_CONTRACTORATTENDANCE_GET_CUSTOMERPOSITION_RECRUITMENT_CONTRACTOR, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}